import styled from '@emotion/styled'
import { color, font, size } from '../../../styles'
import Avatar from '../Avatar'
import { RoleCardProps } from '../RoleCard'

interface MiniRoleCardProps
   extends Pick<
      RoleCardProps['role'],
      'displayName' | 'email' | 'companyName' | 'type' | 'avatarImage' | 'id'
   > {}

const MiniRoleCard: React.FC<MiniRoleCardProps> = (props: MiniRoleCardProps) => {
   const { displayName, email, companyName, type } = props

   const avatarProps = {
      roles: [
         {
            displayName: props.displayName as string,
            avatarImage: props.avatarImage,
         },
      ],
      maxAvatarsToShow: 1,
   }
   return (
      <Holder className={type + ' min-role-card'}>
         <Avatar {...avatarProps} className="avatar-image" />
         <div className="role-info">
            <h4>{displayName}</h4>
            <p className="company-name">{companyName}</p>
            <address>{email}</address>
         </div>
         <div className="role-type">{type}</div>
      </Holder>
   )
}

const Holder = styled.div`
   display: flex;
   align-items: center;
   padding: 0.4em 0.4em;
   isolation: isolate;
   gap: 0.7em;
   position: relative;
   width: 100%;
   scale: 0.9;
   transform-origin: 0 0;

   --color: #000;

   .role-type {
      position: absolute;
      top: 0.6em;
      right: 0em;
      color: ${color.white};
      background-color: var(--color);
      font-size: ${size.xs};
      ${font.regular};
      padding: 0.15em 1em;
      text-transform: capitalize;
      border-radius: 1.1em;
      width: var(--role-type-width);
      text-align: center;
      scale: 0.85;
      width: 4.4em;
   }

   .role-info {
      display: flex;
      flex-direction: column;
      max-width: calc(100% - 5em);

      p,
      h4,
      address {
         margin: 0;
         padding: 0;
         overflow: hidden;
         text-overflow: ellipsis;
         white-space: nowrap;
      }

      h4 {
         color: var(--color);
      }

      .company-name {
         color: ${color.black};
         ${font.regular};
         margin-bottom: 0.1em;
      }

      address {
         color: ${color.grayDark};
      }
   }

   &.tenant {
      --color: #2f2489;
   }
   &.owner {
      --color: #8fad2a;
   }
   &.vendor {
      --color: #d27638;
   }
   &.manager {
      --color: #000;
   }
   &.employee {
      --color: #663819;
   }
`

export type { MiniRoleCardProps }
export default MiniRoleCard
